import React, { createContext, useContext, useState, useEffect } from 'react';

const LocationContext = createContext();

export const useLocationContext = () => useContext(LocationContext);

const LOCAL_STORAGE_KEY = 'user_location';

export const LocationProvider = ({ children }) => {
  const [address, setAddressState] = useState(null);
  const [coords, setCoordsState] = useState(null);

  // Load from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored) {
      try {
        const { address, coords } = JSON.parse(stored);
        if (address) setAddressState(address);
        if (coords) setCoordsState(coords);
      } catch { }
    }
  }, []);

  // Save to localStorage whenever address or coords change
  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ address, coords }));
  }, [address, coords]);

  // Sync across tabs
  useEffect(() => {
    const handler = (e) => {
      if (e.key === LOCAL_STORAGE_KEY && e.newValue) {
        try {
          const { address, coords } = JSON.parse(e.newValue);
          if (address) setAddressState(address);
          if (coords) setCoordsState(coords);
        } catch { }
      }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  // Setters that update both state and localStorage
  const setAddress = (addr) => setAddressState(addr);
  const setCoords = (c) => setCoordsState(c);

  return (
    <LocationContext.Provider value={{ address, setAddress, coords, setCoords }}>
      {children}
    </LocationContext.Provider>
  );
}; 